import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function PainPoints() {
  const desires = ['Caminar hasta el almacén sin pensar en la vuelta', 'Salir a dar una vuelta sin estar contando pasos', 'Subir un escalón sin apretar la mandíbula', 'Levantarte de la silla sin hacerte el fuerte'];
  return <Section background="light" data-id="element-282">
      <FadeIn data-id="element-283">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10" data-id="element-284">
          Lo que realmente querés
        </h2>

        <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 md:p-10 border border-[#D8F3DC]" data-id="element-285">
          <p className="text-xl text-center mb-8 font-medium text-[#1B4332]" data-id="element-286">
            Vos no querés "hacer ejercicio". Vos querés poder:
          </p>

          <ul className="space-y-4 mb-8" data-id="element-287">
            {desires.map((item, index) => <li key={index} className="flex items-start" data-id="element-288">
                <CheckCircle2 className="h-6 w-6 text-[#40916C] mr-4 flex-shrink-0 mt-0.5" data-id="element-289" />
                <span className="text-lg text-[#1A1A1A]" data-id="element-290">{item}</span>
              </li>)}
          </ul>

          <div className="text-center pt-6 border-t border-gray-100" data-id="element-291">
            <p className="text-xl font-serif italic text-[#1B4332]" data-id="element-292">
              Y sobre todo: querés que mañana no sea la factura de hoy.
            </p>
          </div>
        </div>
      </FadeIn>
    </Section>;
}